import useSWR from "swr"
import { GovernanceConfigApi } from "../../../apis"

export function useGovernanceConfigQuery() {
  return useSWR(
    ["governance-config"],
    async () => GovernanceConfigApi.get(),
    { revalidateOnFocus: false },
  )
}
